import { createRouter, createWebHistory } from 'vue-router';
import { dropStaleErrorDetails } from '@/views/Errors/errorDetails';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.afterEach(to => dropStaleErrorDetails(to.name));

export default router;
